import { create } from "zustand";
import { persist } from "zustand/middleware";

/** "all" = Wszystko; the space filter is a lens, not a separate system (PLAN §1). */
export type SpaceFilter = "all" | "praca" | "prywatne";

export const SPACE_LABELS: Record<SpaceFilter, string> = {
  all: "Wszystko",
  praca: "Praca",
  prywatne: "Prywatne",
};

interface AppState {
  space: SpaceFilter;
  setSpace: (space: SpaceFilter) => void;
}

/** Faza 3: zmiana przestrzeni leci też eventem `space.switch` (patrz chat/useChat). */
export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      space: "all",
      setSpace: (space) => set({ space }),
    }),
    { name: "gtd-app-state" },
  ),
);
